module.exports = __webpack_public_path__ + "img/pin-15.7b152873.svg";